<template>
  <div class="select">
    <div class="wrapper">
      <div class="container">
        <div class="left">
          <div class="content">
            <reset-action />
            <h1>Deze subsidie sluit het beste aan bij jouw wensen.</h1>
          </div>
        </div>
        <div class="right">
          <div class="content" id="main">
            <div class="inner">
              <div class="rows">
                <a
                  href="https://www.erasmusplus.nl/subsidie/middelbaar-beroepsonderwijs/mogelijkheden/partnerschappen/cooperation-partnerships"
                  title="erasmusplus.nl"
                  target="_blank"
                  rel="noopener"
                  class="col"
                >
                  <span>Cooperation Partnership (KA220-VET)</span>
                  <p>Key Action 2: Cooperation Partnerships in Vocational Education and Training</p>
                  <button class="button">
                    Meer informatie
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) -->
                      <path
                        d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                      />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../style/result-one";
</style>
